import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { ApiUrl } from '../../../services/ApiRest';
import { Link } from 'react-router-dom';

const PartnersList = () => {

    const [data, setdata] = useState([]);

    const dataListSuppliers = async () => {
        try {
            const response = await axios.get(ApiUrl + `partner-list`);
            const responseData = response.data;
            setdata(responseData);
            console.log('Todas la Suppliers:', responseData);
            const script = document.createElement("script");
            script.src = `/assets/dataTable/dataTable.js`;
            script.async = true;
            document.body.appendChild(script);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        dataListSuppliers();
    }, [])


    return (
        <>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className=" card-header">
                            <div className='row'>
                                <div className='col-12 col-md-6'>
                                    <b>LISTA DE PARTNERS</b>
                                </div>
                                <div className='col-12 col-md-6 ' style={{ textAlign: 'right' }}>
                                    <Link to="/administrativo/partners-add" className="btn btn-success btn-sm">
                                        <b>CREAR PARTNER <i className="fa fa-plus" aria-hidden="true"></i></b>
                                    </Link>

                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive">
                            <table className='table table-hover ' id="dataTable-ord-col1"  >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>Direccíon</th>
                                        <th>Ciudad</th>
                                        <th>Categoría</th>
                                        <th>Propietario</th>
                                        <th>Teléfono</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((dataPartner, i) => (
                                        <tr key={dataPartner.partner_id}>
                                            <td>{i + 1}</td>
                                            <td>{dataPartner.partner_name}</td>
                                            <td>{dataPartner.address}</td>
                                            <td>{dataPartner.city}</td>
                                            <td>{dataPartner.category}</td>
                                            <td>{dataPartner.manager}</td>
                                            <td>{dataPartner.phone}</td>
                                            {/* <td> */}
                                            {/* <button className='btn btn-outline-primary' data-bs-toggle="modal" data-bs-target="#editProductModal" onClick={() => { setformD({ suppliers_id: dataPartner.suppliers_id, name_store: dataPartner.name_store, address: dataPartner.address, owner: dataPartner.owner, phone: dataPartner.phone }); }}><i className="fas fa-pen" aria-hidden="true"></i></button> */}
                                            {/* <button className='btn btn-outline-danger' data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => { setsupplierId(dataPartner.suppliers_id); setsupplierName(dataPartner.name_store); }} ><i className="fas fa-trash-alt" aria-hidden="true"></i></button> */}
                                            {/* </td> */}
                                            <td>
                                                <Link to={"../partner-edit/" + dataPartner.partner_id}>
                                                    <button className='btn btn-outline-primary btn-sm'><i className="fas fa-pen" aria-hidden="true"></i></button>
                                                </Link>
                                            </td>

                                        </tr>
                                    ))
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PartnersList
